import PanelContent from './component';

export default PanelContent;
